import { useLocation } from 'react-router-dom';

const useIsLoginPath = () => {
  const location = useLocation();

  // Mengecek apakah path saat ini adalah "/login"
  return location.pathname === '/sales';
};

export default useIsLoginPath;
